import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../Customize_Css/Pagination.css';
import {Dropdown,Modal,Button} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaTrashAlt, FaFileExport, FaEdit, FaSearch, FaEye, FaTruck } from 'react-icons/fa';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import '../Customize_Css/ViewVendor.css';
import axios from 'axios';  
import { toast, ToastContainer } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css'; 
import * as XLSX from 'xlsx';

const ViewDeliveryVendor = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const AuthorizationToken = localStorage.getItem('token');

    const navigate = useNavigate();
    const [data, setData] = useState([]);  
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [selectedItems, setSelectedItems] = useState([]);
    const [originalData, setOriginalData] = useState([]); 
    const epicxTenantId = localStorage.getItem('epicxTenantId');
    const [selectedDeliveryVendor, setSelectedDeliveryVendor] = useState(null);
    const [showModal, setShowModal] = useState(false);
    
    const formatDate = (dateString) => {
        const options = { day: '2-digit', month: 'long', year: 'numeric' };
        return new Date(dateString).toLocaleDateString('en-GB', options).replace(/ /g, '-');
    };
    
    // Fetch delivery vendors from API
    useEffect(() => {
        const fetchDeliveryVendors = async () => {
            if (!epicxTenantId) {
                console.error('Tenant ID is not provided');
                return;
            }
            try {
                const response = await axios.get(`${BASE_URL}/deliveryVendor/api/deliveryVendor/${epicxTenantId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${AuthorizationToken}`,
                          },
                        }
                );
                setData(response.data); 
                setOriginalData(response.data);
            } catch (error) {
                console.error("Error fetching delivery vendors:", error);
            }
        };
        fetchDeliveryVendors();
    }, [epicxTenantId]);

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
        setData((prevData) => {
            return [...prevData].sort((a, b) => {
                if (a[key] < b[key]) {
                    return direction === 'asc' ? -1 : 1;
                }
                if (a[key] > b[key]) {
                    return direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        });
    };

    const handleSearch = (value) => {
        setSearchTerm(value.toLowerCase());
        if (value.trim() === '') {
            setData(originalData); 
        } else {
            const filteredData = originalData.filter((item) =>
                Object.keys(item).some((key) =>
                    item[key].toString().toLowerCase().includes(value.toLowerCase())  
                )
            );
            setData(filteredData);
        }
        setCurrentPage(1);  
    };    

    const handleSelectAll = () => {
        if (selectedItems.length === data.length) {
            setSelectedItems([]);
        } else {
            setSelectedItems(data.map(item => item._id));
        }
    };

    const handleSelectItem = (_id) => {
        if (selectedItems.includes(_id)) {
            const newSelectedItems = selectedItems.filter(item => item !== _id);
            setSelectedItems(newSelectedItems);
        } else {
            setSelectedItems([...selectedItems, _id]);
        }
    };
    // Delete selected items 
    const handleDelete = async () => {
        if (selectedItems.length === 0) {
            toast.warn("No items selected to delete");
            return;
        }
        const confirmed = window.confirm("Are you sure you want to delete the selected items?");
        if (!confirmed) return;

        try {
            for (const itemId of selectedItems) {
                const response = await axios.put(`${BASE_URL}/deliveryVendor/api/deliveryVendor/${epicxTenantId}/delete/${itemId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${AuthorizationToken}`,
                          },
                        }
                );
                console.log(`Item with id ${itemId} deleted`, response);
            }
            setData(data.filter(item => !selectedItems.includes(item._id)));
            setSelectedItems([]);
            toast.success("Selected items deleted successfully!");
        } catch (error) {
            console.error("Error deleting items:", error);
            toast.error("Error deleting items. Please try again.");
        }
    };
    const handleEdit = () => {
        if (selectedItems.length === 1) {
            const [selectedId] = selectedItems; 
            navigate(`/updateDeliveryVendor/${selectedId}`); 
        } else {
            toast.error("Please select exactly one Delivery Vendor to edit");
        }
    };
    const handleExport = () => {
        const dataToExport = selectedItems.length > 0 
            ? data.filter(item => selectedItems.includes(item._id)) 
            : data;
        const exportData = dataToExport.map(item => ({
            deliveryVendorShopName: item.deliveryVendorShopName,
            fullName: item.fullName,
            emailAddress:item.emailAddress,
            degree: item.degree,
            primaryMobileNumber: item.primaryMobileNumber,
            whatsappNumber: item.whatsappNumber,
            country: item.country,
            state: item.state,
            city: item.city,
            dateOfBirth: item.dateOfBirth,
            gstNumber: item.gstNumber,
            panNumber: item.panNumber,
            address: item.address,
            useMyLocation: item.useMyLocation,
            currentLocation: item.currentLocation,
            timeAvailabilitySlot: item.timeAvailabilitySlot.join(', '),
            daySlot: item.daySlot.join(', '),
            nameOfEmergency: item.nameOfEmergency,
            relationshipToAccountHolder: item.relationshipToAccountHolder,
            emergencyPhoneNumber: item.emergencyPhoneNumber,
            emergencyEmailAddress: item.emergencyEmailAddress,
            alternateContactPersonName: item.alternateContactPersonName,
            relationshipToAlternateContactPerson: item.relationshipToAlternateContactPerson,
            alternateContactPersonNumber:item.alternateContactPersonNumber,
            alternateContactPersonAddress:item.alternateContactPersonAddress,
            toPickupLocationTime:item.toPickupLocationTime,
            toDeliveryLocationTime:item.toDeliveryLocationTime,
            maximumDeliveryCapacity:item.maximumDeliveryCapacity,
            accountHoldersName:item.accountHoldersName,
            typeOfAccount:item.typeOfAccount,
            accountNumber:item.accountNumber,
            ifscCode:item.ifscCode,
            branchName:item.branchName,
            gpayNumber:item.gpayNumber,
            bankAddress:item.bankAddress,
            createdAt:item.createdAt,
            updatedAt:item.updatedAt
        }));
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "DeliveryVendors");
        XLSX.writeFile(wb, 'DeliveryVendors_data.xlsx');
    };
    const handleViewDetails = (deliveryVendorId) => {
        const deliveryVendor = data.find((item) => item._id === deliveryVendorId);
        if (deliveryVendor) {
            setSelectedDeliveryVendor(deliveryVendor);
            setShowModal(true);
        }
    };

    // Pagination Logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = data.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(data.length / itemsPerPage);

    const deliveryColumns = [
        { key: 'deliveryVendorShopName', label: 'Delivery Vendor Shop Name' },
        { key: 'gstNumber', label: 'GST Number' },
        { key: 'primaryMobileNumber', label: 'Phone Number' },
        { key: 'emailAddress', label: 'Email Id' },
        { key: 'address', label: 'Address' },
        { key: 'panNumber', label: 'PAN Number' },
    ];

    return (
        <>
            <Sidebar />
            <div className="vendors-page">
                <header className="vendors-hero">
                    <div>
                        <p className="vendors-kicker">Vendors</p>
                        <h1>Delivery Vendor List</h1>
                        <p>Browse, find, and manage delivery vendors for your store.</p>
                    </div>
                    <button
                        className="vendors-primary-btn"
                        onClick={() => navigate('/add-delivery-vendor')}
                    >
                        <FaPlus /> Add Delivery Vendor
                    </button>
                </header>

                <section className="vendors-toolbar" aria-label="Delivery vendor search and actions">
                    <div className="vendors-search">
                        <FaSearch aria-hidden="true" />
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search delivery vendors..."
                            aria-label="Search delivery vendors"
                            value={searchTerm}
                            onChange={(e) => handleSearch(e.target.value)}
                        />
                    </div>
                    <Dropdown>
                        <Dropdown.Toggle className="vendors-action-btn">
                            Actions
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={handleDelete} disabled={selectedItems.length === 0}>
                                <FaTrashAlt className="me-2" /> Delete
                            </Dropdown.Item>
                            <Dropdown.Item onClick={handleExport}>
                                <FaFileExport className="me-2" /> Export
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </section>

                <div className="vendors-card">
                    <div className="vendors-card-head">
                        <div>
                            <h2>All Delivery Vendors</h2>
                            <p>Select a vendor to edit, delete, or view full details.</p>
                        </div>
                        <span className="vendors-count">
                            <FaTruck aria-hidden="true" />
                            {data.length} {data.length === 1 ? 'vendor' : 'vendors'}
                        </span>
                    </div>
                    <div className="vendors-card-body">
                        <div className="vendors-table-wrap no-scroll">
                            <table className="vendors-table vendors-table-full">
                                <colgroup>
                                    <col className="col-check" />
                                    <col className="col-shop" />
                                    <col className="col-gst" />
                                    <col className="col-phone" />
                                    <col className="col-email" />
                                    <col className="col-address" />
                                    <col className="col-pan" />
                                    <col className="col-action" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th className="vendors-check-cell">
                                            <input
                                                className="vendors-checkbox"
                                                type="checkbox"
                                                aria-label="Select all delivery vendors"
                                                checked={data.length > 0 && selectedItems.length === data.length}
                                                onChange={handleSelectAll}
                                            />
                                        </th>
                                        {deliveryColumns.map((column) => (
                                            <th
                                                key={column.key}
                                                className={column.key === 'deliveryVendorShopName' ? 'vendors-sticky-name' : undefined}
                                                onClick={() => handleSort(column.key)}
                                            >
                                                {column.label}
                                                {sortConfig.key === column.key ? (sortConfig.direction === 'asc' ? ' ▲' : ' ▼') : ''}
                                            </th>
                                        ))}
                                        <th className="vendors-action-cell">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.length > 0 ? currentData.map((item) => (
                                        <tr key={item._id} className={selectedItems.includes(item._id) ? 'is-selected' : ''}>
                                            <td className="vendors-check-cell">
                                                <input
                                                    className="vendors-checkbox"
                                                    type="checkbox"
                                                    aria-label={`Select ${item.deliveryVendorShopName}`}
                                                    checked={selectedItems.includes(item._id)}
                                                    onChange={() => handleSelectItem(item._id)}
                                                />
                                            </td>
                                            <td className="vendors-sticky-name"><span className="vendor-name">{item.deliveryVendorShopName}</span></td>
                                            <td><span className="vendor-gst">{item.gstNumber}</span></td>
                                            <td>{item.primaryMobileNumber}</td>
                                            <td>{item.emailAddress}</td>
                                            <td className="vendors-address-cell">{item.address}</td>
                                            <td>{item.panNumber}</td>
                                            <td className="vendors-action-cell">
                                                <div className="vendors-action-group">
                                                    <button
                                                        type="button"
                                                        className="vendors-icon-btn vendors-icon-btn--view"
                                                        aria-label={`View details for ${item.deliveryVendorShopName}`}
                                                        title="View details"
                                                        onClick={() => handleViewDetails(item._id)}
                                                    >
                                                        <FaEye aria-hidden="true" />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="vendors-icon-btn vendors-icon-btn--edit"
                                                        aria-label={`Edit ${item.deliveryVendorShopName}`}
                                                        title="Edit vendor"
                                                        onClick={() => navigate(`/updateDeliveryVendor/${item._id}`)}
                                                    >
                                                        <FaEdit aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="8">
                                                <div className="vendors-empty">
                                                    <span><FaTruck aria-hidden="true" /></span>
                                                    <h3>No delivery vendors found</h3>
                                                    <p>Try another search or add a new delivery vendor.</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="vendors-card-footer">
                        <span className="vendors-page-summary">
                            {data.length > 0
                                ? `Showing ${indexOfFirstItem + 1}–${Math.min(indexOfLastItem, data.length)} of ${data.length}`
                                : 'Showing 0 delivery vendors'}
                        </span>
                        <div className="vendors-pagination">
                            <nav>
                                <ul className="pagination mb-0" aria-label="Delivery vendors pagination">
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link btn-sm" onClick={() => setCurrentPage(1)} aria-label="First page">&laquo;</button>
                                    </li>
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link btn-sm" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} aria-label="Previous page">&lt;</button>
                                    </li>
                                    <li className="page-item active">
                                        <button className="page-link btn-sm" aria-current="page">{currentPage}</button>
                                    </li>
                                    <li className={`page-item ${currentPage === totalPages || totalPages === 0 ? 'disabled' : ''}`}>
                                        <button className="page-link btn-sm" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} aria-label="Next page">&gt;</button>
                                    </li>
                                    <li className={`page-item ${currentPage === totalPages || totalPages === 0 ? 'disabled' : ''}`}>
                                        <button className="page-link btn-sm" onClick={() => setCurrentPage(totalPages || 1)} aria-label="Last page">&raquo;</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>

                <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" centered dialogClassName="vendor-details-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Delivery Vendor Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedDeliveryVendor ? (
                            <div className="vendor-details-content">
                                <div className="vendor-details-title">
                                    {selectedDeliveryVendor.profilePictureFile ? (
                                        <img className="vendor-details-photo" src={selectedDeliveryVendor.profilePictureFile} alt={selectedDeliveryVendor.fullName || 'Profile'} />
                                    ) : (
                                        <span><FaTruck aria-hidden="true" /></span>
                                    )}
                                    <div>
                                        <small>Delivery vendor</small>
                                        <h3>{selectedDeliveryVendor.fullName || 'N/A'}</h3>
                                        <p>{selectedDeliveryVendor.deliveryVendorShopName || 'Shop name not added'}</p>
                                    </div>
                                </div>
                                <div className="vendor-details-grid">
                                    <div><span>Degree</span><strong>{selectedDeliveryVendor.degree || 'N/A'}</strong></div>
                                    <div><span>WhatsApp</span><strong>{selectedDeliveryVendor.whatsappNumber || 'N/A'}</strong></div>
                                    <div><span>Date of Birth</span><strong>{selectedDeliveryVendor.dateOfBirth ? formatDate(selectedDeliveryVendor.dateOfBirth) : 'N/A'}</strong></div>
                                    <div><span>Country</span><strong>{selectedDeliveryVendor.country || 'N/A'}</strong></div>
                                    <div><span>State</span><strong>{selectedDeliveryVendor.state || 'N/A'}</strong></div>
                                    <div><span>City</span><strong>{selectedDeliveryVendor.city || 'N/A'}</strong></div>
                                    <div className="details-wide"><span>Address</span><strong>{selectedDeliveryVendor.address || 'N/A'}</strong></div>
                                </div>

                                <section className="vendor-details-section">
                                    <h4>Emergency Contact</h4>
                                    <div className="vendor-details-grid">
                                        <div><span>Name</span><strong>{selectedDeliveryVendor.nameOfEmergency || 'N/A'}</strong></div>
                                        <div><span>Relationship</span><strong>{selectedDeliveryVendor.relationshipToAccountHolder || 'N/A'}</strong></div>
                                        <div><span>Phone</span><strong>{selectedDeliveryVendor.emergencyPhoneNumber || 'N/A'}</strong></div>
                                        <div><span>Email</span><strong>{selectedDeliveryVendor.emergencyEmailAddress || 'N/A'}</strong></div>
                                    </div>
                                </section>

                                <section className="vendor-details-section">
                                    <h4>Documents</h4>
                                    <div className="vendor-details-grid">
                                        <div><span>GST Number</span><strong>{selectedDeliveryVendor.gstNumber || 'N/A'}</strong></div>
                                        <div><span>PAN Number</span><strong>{selectedDeliveryVendor.panNumber || 'N/A'}</strong></div>
                                        <div>
                                            <span>Files</span>
                                            <strong className="vendor-detail-chips">
                                                {selectedDeliveryVendor.gstFile && (
                                                    <a href={selectedDeliveryVendor.gstFile} target="_blank" rel="noopener noreferrer" className="vendors-view-btn">
                                                        <FaEye aria-hidden="true" /> View GST File
                                                    </a>
                                                )}
                                                {selectedDeliveryVendor.panFile && (
                                                    <a href={selectedDeliveryVendor.panFile} target="_blank" rel="noopener noreferrer" className="vendors-view-btn">
                                                        <FaEye aria-hidden="true" /> View PAN File
                                                    </a>
                                                )}
                                            </strong>
                                        </div>
                                    </div>
                                </section>

                                <section className="vendor-details-section">
                                    <h4>Availability</h4>
                                    <div className="vendor-details-grid">
                                        <div className="details-wide">
                                            <span>Time Slots</span>
                                            <div className="vendor-detail-chips">
                                                {(selectedDeliveryVendor.timeAvailabilitySlot || []).length > 0
                                                    ? selectedDeliveryVendor.timeAvailabilitySlot.map((slot) => <span key={slot}>{slot}</span>)
                                                    : <strong>N/A</strong>}
                                            </div>
                                        </div>
                                        <div className="details-wide">
                                            <span>Days Available</span>
                                            <div className="vendor-detail-chips">
                                                {(selectedDeliveryVendor.daySlot || []).length > 0
                                                    ? selectedDeliveryVendor.daySlot.map((day) => <span key={day}>{day}</span>)
                                                    : <strong>N/A</strong>}
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className="vendor-details-section">
                                    <h4>TAT Calculation</h4>
                                    <div className="vendor-details-grid">
                                        <div><span>Pickup Time</span><strong>{selectedDeliveryVendor.toPickupLocationTime || 'N/A'}</strong></div>
                                        <div><span>Delivery Time</span><strong>{selectedDeliveryVendor.toDeliveryLocationTime || 'N/A'}</strong></div>
                                        <div><span>Max Delivery Capacity</span><strong>{selectedDeliveryVendor.maximumDeliveryCapacity || 'N/A'}</strong></div>
                                    </div>
                                </section>

                                <section className="vendor-details-section">
                                    <h4>Bank Details</h4>
                                    <div className="vendor-details-grid">
                                        <div><span>Account Holder</span><strong>{selectedDeliveryVendor.accountHoldersName || 'N/A'}</strong></div>
                                        <div><span>Type of Account</span><strong>{selectedDeliveryVendor.typeOfAccount || 'N/A'}</strong></div>
                                        <div><span>Account Number</span><strong>{selectedDeliveryVendor.accountNumber || 'N/A'}</strong></div>
                                        <div><span>IFSC Code</span><strong>{selectedDeliveryVendor.ifscCode || 'N/A'}</strong></div>
                                        <div><span>Branch Name</span><strong>{selectedDeliveryVendor.branchName || 'N/A'}</strong></div>
                                        <div><span>GPay Number</span><strong>{selectedDeliveryVendor.gpayNumber || 'N/A'}</strong></div>
                                    </div>
                                </section>

                                <div className="vendor-details-grid">
                                    <div><span>Created At</span><strong>{selectedDeliveryVendor.createdAt ? formatDate(selectedDeliveryVendor.createdAt) : 'N/A'}</strong></div>
                                    <div><span>Updated At</span><strong>{selectedDeliveryVendor.updatedAt ? formatDate(selectedDeliveryVendor.updatedAt) : 'N/A'}</strong></div>
                                </div>
                            </div>
                        ) : (
                            <p className="vendor-details-empty">No vendor details available.</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="vendors-modal-close" onClick={() => setShowModal(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                <div className="vendors-footer">
                    <Footer />
                </div>
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    style={{ zIndex: 9999 }}
                />
            </div>
        </>
    );
};

export default ViewDeliveryVendor;
